import { render, staticRenderFns } from "./PurchaseReturnMgmt.vue?vue&type=template&id=744b9f22"
import script from "./PurchaseReturnMgmt.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnMgmt.vue?vue&type=script&lang=js"
import style0 from "./PurchaseReturnMgmt.vue?vue&type=style&index=0&id=744b9f22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports